module.exports = __webpack_public_path__ + "static/media/consensys-3.6bed0427.jpg";